"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBase64FromUrl = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../commonFiles/helpers");
const URLs_1 = require("../utility/URLs");
const helpers_2 = require("../../commonFiles/helpers");
const getBase64FromUrl = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const data = (yield URLs_1.Api.fetchBase64DataFromUrl(url)).data;
        console.log('getBase64FromUrl data', data.length);
        return data;
    }
    catch (error) {
        (0, helpers_2.logError)(error);
    }
});
exports.getBase64FromUrl = getBase64FromUrl;
function ImagePicker(props) {
    const setImage = props.setImage;
    const maxSize = props.maxSize;
    const [url, seturl] = react_1.default.useState(null);
    const [fromURL, setFromURL] = react_1.default.useState(false);
    return (react_1.default.createElement("div", { className: '' },
        react_1.default.createElement("div", { className: 'd-flex align-items-center' },
            react_1.default.createElement("div", { className: 'mx-1' }, "\u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637"),
            react_1.default.createElement("input", { type: 'checkbox', onChange: e => setFromURL(e.target.checked) })),
        !fromURL ?
            react_1.default.createElement("div", { className: 'd-flex align-items-center' },
                react_1.default.createElement("div", { className: 'mx-1' }, "\u0645\u0646 \u0627\u0644\u0645\u0644\u0641\u0627\u062A"),
                react_1.default.createElement("input", { type: 'file', accept: ".jpg,.jpeg,.png,.webp,.gif", onChange: (e) => {
                        const file = e.target.files[0];
                        (0, helpers_1.convertFileToBase64)(file).then((base64) => {
                            if (base64.length > maxSize)
                                alert('حجم الصورة يجب ان لا يفوق ' + maxSize);
                            else
                                setImage(base64);
                        });
                    } }))
            :
                react_1.default.createElement("div", { className: 'd-flex' },
                    react_1.default.createElement("div", { className: 'my-2 d-flex mx-2' },
                        react_1.default.createElement("div", { className: 'mx-2' }, "\u0645\u0646 \u0627\u0644\u0631\u0627\u0628\u0637"),
                        react_1.default.createElement("input", { onChange: (e) => seturl(e.target.value) })),
                    react_1.default.createElement("button", { className: 'btn btn-success', onClick: () => {
                            (0, exports.getBase64FromUrl)(url).then((base64) => {
                                if (base64.length > maxSize)
                                    alert('حجم الصورة يجب ان لا يفوق ' + maxSize);
                                else
                                    setImage(base64);
                            });
                        } }, "\u062C\u0644\u0628 \u0627\u0644\u0635\u0648\u0631\u0629"))));
}
exports.default = ImagePicker;
